
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2025.
 * Title: EmmeEvolution_Marketplace.ts;
 * Path: ./src/environments/BaseEnvironments/EmmeEvolution_Marketplace.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 31/03/26, 11:53;
 * Updated at: 31/03/26, 11:53;
 *
 */

import { getModule, addModule } from '../Utility/ModuleUtility';
import {EnvironmentModel} from "./Model";
import {CatalogoEnv} from "../Modules/Marketplace/Catalogo";
import {PreferitiEnv} from "../Modules/Marketplace/Preferiti";
import {SeguiEnv} from "../Modules/Marketplace/Segui";
import {I_miei_OrdiniEnv} from "../Modules/Marketplace/I miei Ordini";
import {Ordini_RicevutiEnv} from "../Modules/Marketplace/Ordini_Ricevuti";
import {ListaProdottiEnv} from "../Modules/Marketplace/Lista Prodotti";
import {Le_mie_ricercheEnv} from "../Modules/Marketplace/Le_mie_ricerche";
import {OrdiniEnv} from "../Modules/Marketplace/Admin/Ordini";
import {CatalogoModerazioneEnv} from "../Modules/Marketplace/Admin/CatalogoModerazione";
import {UtentiEnv} from "../Modules/Marketplace/Admin/Utenti";
import {StagioniEnv} from "../Modules/Marketplace/Admin/Stagioni";
import {dettaglio_negozioEnv} from "../Modules/Marketplace/dettaglio_negozio";
import {config_prodottoEnv} from "../Modules/Marketplace/Admin/config_prodotto";
import {DashboardEnv} from "../Modules/Marketplace/Dashboard";
import {config_marketplaceEnv} from "../Modules/Marketplace/Admin/config_marketplace";
var Environment = () => {
  var env: any = {};
  env.href = '/Login/marketplace'
  env.style = "Marketplace"
  env.theme = 'light';
  env.sidebarbg = 'skin6';
  env.toastrTime = 10000;
  env.oreScadenzaOrdine = 48;
  env.MainColor = '#3B4AD6';
  env.navbarbg =  '#3B4AD6';
  env.navbarAccentColor = '#0F766E00';
  env.InputLabelColor = '#333333';
  env.InputTextColor =  "#4d4d4d";
  env.BreadcrumbType = "MenuBased";
  env.logoPath = 'assets/images/logo_ioneeo-04.png';
  env.logoBg = "white";
  env.icon = 'assets/images/logo_ioneeo-02.png';
  env.fontFamily = "Poppins";
  env.Modules = {
    'Progetti': true
  };
  env = getModule(env);
  env.langSuffix= '_Marketplace.json';
  env.baseUrl= 'marketplace/shared/dynamiclist/catalogo';
  env.CustomConfirmPage=true;
  env.iconClasses = {
    error: 'marketplace-toast-error',
    info: 'marketplace-toast-info',
    success: 'marketplace-toast-success',
    warning: 'marketplace-toast-warning'
  };

  env.ProgettiAddon= {
    valOfferta: true,
      valAccettato: true,
      filters: [
      { nome: 'Completate', oggetti: ['chiusi'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3' },
      { nome: 'Annullate', oggetti: ['annullati'], modificabile: true, inputType: 'checkbox', class: 'col-lg-3' },
    ],
      TipiProgetto: [
      {
        nome: 'Offerta',
        id: "O",
        colore: "#1baa03",
        restRoute: "/progetti/progetti",
        capacita: [],
        defaultFilter:{tipoOfferta: "O"}
      },
    ],
      valCanone: true,
      CampiAggiuntivi: [ // campi aggiuntiv voci di costo
      { nome: 'Descrizione', oggetti: ['descrizione'], modificabile: true, inputType: 'textarea'}
    ],
      CampiOfferta: [
      {
        modificabile: true,
        nome: 'Valore Offerto',
        oggetti: ['valOfferta'],
        inputType: 'numeric',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Valore Accettato',
        oggetti: ['valAccettato'],
        inputType: 'numeric',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Valore Canone',
        oggetti: ['valCanone'],
        inputType: 'numeric',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Data di scadenza',
        oggetti: ['dataScadenza'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
    ],
      CampiSottoOfferta: []
  }
  env.Menu = [

  ];

  return env;
};

var FullEnv = () => {
  var env: any = {};
  env = Environment();
  env = addModule(dettaglio_negozioEnv(), env);
  env = addModule(StagioniEnv(), env);
  env = addModule(OrdiniEnv(), env);
  env = addModule(config_marketplaceEnv(), env);
  env = addModule(config_prodottoEnv(), env);
  env = addModule(CatalogoModerazioneEnv(), env);
  env = addModule(UtentiEnv(), env);
  env = addModule(DashboardEnv(), env);
  env = addModule(ListaProdottiEnv(), env);
  env = addModule(Ordini_RicevutiEnv(), env);
  env = addModule(I_miei_OrdiniEnv(), env);
  env = addModule(SeguiEnv(),env);
  env = addModule(Le_mie_ricercheEnv(), env);
  env = addModule(PreferitiEnv(), env);
  env = addModule(CatalogoEnv(), env);
  return env;
};

export var environment: any = FullEnv();
